const scope = {
    name_exists: 'اسم النطاق {{name}} مستخدم بالفعل',
    name_with_space: 'اسم النطاق لا يمكن أن يحتوي على أي مسافات.',
};
export default Object.freeze(scope);
